const LEFT = [
  "Exclusive Premium Himalayan Sea Buckthorn",
  "Wild-grown",
  "Hand-harvested and sustainable",
  "Highest omega-7 content in the world",
  "Supercritical CO₂ extraction — the gold standard for clean, pure and eco-friendly oil",
];

const RIGHT = [
  "Export-ready documentation",
  "USDA Organic support where applicable",
  "FDA-registered facility",
  "Batch and COA testing support",
  "Finished-format support for softgels and gummies where available",
];

function HALogo() {
  // Same brand mark used in the Header — leaf-style company logo
  return (
    <svg viewBox="0 0 120 72" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Himalayan Actives logo" className="ha-logo-svg">
      <path d="M58 68 C58 48 58 31 58 8" stroke="#d9a74a" strokeWidth="5" strokeLinecap="round" fill="none" />
      <path d="M58 39 C38 24 24 19 8 23 C20 42 36 51 58 39Z" fill="#d9a74a" />
      <path d="M62 39 C82 24 96 19 112 23 C100 42 84 51 62 39Z" fill="#d9a74a" />
      <path d="M58 66 C37 58 22 50 5 50 C16 66 34 72 58 66Z" fill="#d9a74a" />
      <path d="M62 66 C83 58 98 50 115 50 C104 66 86 72 62 66Z" fill="#d9a74a" />
      <path d="M60 5 C50 17 50 26 60 36 C70 26 70 17 60 5Z" fill="#d9a74a" />
    </svg>
  );
}

export default function Buyers() {
  return (
    <section id="buyers" className="section buyers-section buyers-bg" data-testid="buyers-section">
      <div className="buyers-photo-layer" style={{ backgroundImage: "url(/images/why-buyers.jpg)" }} aria-hidden="true" />
      <div className="buyers-overlay" aria-hidden="true" />
      <div className="wrap" style={{ position: "relative", zIndex: 1 }}>
        <div className="section-head">
          <h2 className="on-photo-title">Why buyers choose us.</h2>
        </div>

        <div className="ha-diff-card" data-testid="ha-difference-card">
          <div className="ha-badge ha-badge-logo">
            <HALogo />
          </div>
          <div>
            <h2 style={{ marginBottom: 14 }}>The HA Difference</h2>
            <p>
              Our high-altitude Himalayan sea buckthorn (Hippophae rhamnoides) is an Omega-7 powerhouse unmatched in
              its nutrient profile. Packed with over 190 bioactive compounds, it thrives in the extreme alpine
              environment and provides brands with unmatched health and beauty positioning. Himalayan Actives brings
              this origin story together with testing, processing and documentation so buyers can evaluate the
              ingredient with confidence.
            </p>
          </div>
        </div>

        <div className="buyer-grid">
          <div className="card-soft" data-testid="buyers-left-card">
            <h3>Your source for premium <span className="sb-orange">sea buckthorn</span> ingredients</h3>
            <div className="checklist">
              {LEFT.map((t) => (
                <div className="check-row" key={t}>
                  <span className="tick">✓</span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="card-soft" data-testid="buyers-right-card">
            <h3>Commercial flexibility</h3>
            <div className="checklist">
              {RIGHT.map((t) => (
                <div className="check-row" key={t}>
                  <span className="tick">✓</span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
